import { CartRepository } from './repositories/cart'
import { CartService } from './services/cart'
import { DiscountRepository } from '../Discount/repositories/discount'

const cartRepository = new CartRepository()
const discountRepository = new DiscountRepository()

const cartService = new CartService({
    cartRepository,
    discountRepository,
})

export { cartService }
